import React, { useEffect, useState, useCallback } from 'react'
import PnLCard from './PnLCardSM.jsx'
import { WalletOutlined, StarOutlined, RiseOutlined } from '@ant-design/icons';
import { GetUserLiveDashboardApi } from '../../../../api/request/liveAccount.js';

const POLLING_INTERVAL = 10000;

const PnLCardGridSM = ({ loginId }) => {
    const [liveData, setLiveData] = useState(null);

    const fetchData = useCallback(async () => {
        if (!loginId) return;
        try {
            const { data } = await GetUserLiveDashboardApi(loginId);
            if (data?.success) {
                setLiveData(data?.data);
            }
        } catch (error) { }
    }, [loginId]);

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, POLLING_INTERVAL);
        return () => clearInterval(interval);
    }, [fetchData]);

    const pnlCards = [
        { type: 'Total Equity', amount: liveData?.equity || 0.00, color: 'bg-blue-500', gradient: 'from-[#FAF5FF] to-[#ffff]', icon: <WalletOutlined size={20} color='#fff' className='text-white' /> },
        { type: 'Total Profit', amount: liveData?.profit || 0.00, color: 'bg-green-500', gradient: 'from-[#F0FDF4] to-[#ffff]', icon: <RiseOutlined size={20} color='#fff' className='text-white' /> },
        { type: 'Used Margin', amount: liveData?.margin || 0.00, color: 'bg-teal-500', gradient: 'from-[#FFF7ED] to-[#ffff]', icon: <StarOutlined size={20} color='#fff' className='text-white' /> },
        { type: 'Free Margin', amount: liveData?.marginFree || 0.00, color: 'bg-red-500', gradient: 'from-[#FFEDED] to-[#ffff]', icon: <StarOutlined size={20} color='#fff' className='text-white' /> }
    ];
    return (
        <div>
            <div className="grid grid-cols-4 gap-3">
                {pnlCards.map((card, index) => (
                    <PnLCard
                        key={card.id || index}
                        type={card.type}
                        amount={card.amount}
                        color={card.color}
                        gradient={card.gradient}
                        icon={card.icon}
                    />
                ))}
            </div>
        </div>
    )
}

export default PnLCardGridSM
